import { PageHeader } from '@/components/layout/PageHeader';
import { QueriesTab } from '@/pages/compliance/QueriesTab';
import { useAuth } from '@/contexts/AuthContext';

export function QueriesPage() {
  const { user } = useAuth();
  const scopeLabel = user?.siteNames?.[user.activeSiteId] ?? 'this site';

  return (
    <div className="space-y-5">
      <PageHeader
        title="Queries"
        subtitle={`Raise, respond to, and close data queries. Scope: ${scopeLabel}.`}
      />
      <QueriesTab />
    </div>
  );
}
